<col [style.width]="'calc(100% / ' + cols + ')'" *ngFor="let i of array">
